import { render, staticRenderFns } from "./WrNotaryCertificateMain.vue?vue&type=template&id=b402e8d0&scoped=true&"
import script from "./WrNotaryCertificateMain.vue?vue&type=script&lang=js&"
export * from "./WrNotaryCertificateMain.vue?vue&type=script&lang=js&"
import style0 from "./WrNotaryCertificateMain.vue?vue&type=style&index=0&id=b402e8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b402e8d0",
  null
  
)

export default component.exports